module.exports = __webpack_public_path__ + "static/media/skywallet_hdk_11.49692b55.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/components/GalleryHDK/images/skywallet_hdk_11.png
// module id = 1436
// module chunks = 0